module.exports = __webpack_public_path__ + "static/media/M004-account.cf540517.svg";